import React from 'react'

export default function Sidebar() {
  return (
    <div className="container">
      <header className="head">
        <img src="./Images/logo.jpg" alt='' />
        <h1>Borex7</h1>
      </header>
      <div className="home">
        <h4>Home</h4>
        <img src="./Images/dashboard icon.png" alt='' />
        <p>Dashboard</p>
        <img src="./Images/dashboard icon.png" alt='' />
        <p>Dashboard</p>
        <img src="./Images/dashboard icon.png" alt='' />
        <p>Dashboard</p>
        <img src="./Images/dashboard icon.png" alt='' />
        <p>Dashboard</p>

        <h4>Events</h4>
        <img src="./Images/calender.png" alt='' />
        <p>Calender</p>
        <img src="./Images/chat.png" alt='' />
        <p>Chat</p>
        <img src="./Images/contacts.png" alt='' />
        <p>Contacts</p>
        <img src="./Images/file.png" alt='' />
        <p>File Manager</p>
        <img src="./Images/mail.png" alt='' />
        <p>Email</p>
        <img src="./Images/insight.png" alt='' />
        <p>Insight</p>

        <h4>Social</h4>
        <img src="./Images/calender.png" alt='' />
        <p>Maps</p>
        <img src="./Images/calender.png" alt='' />
        <p>Education</p>
        <img src="./Images/calender.png" alt='' />
        <p>Crypto</p>
      </div>
    </div>
  )
}
